<template>
  <el-form
    label-position="top"
    :model="form"
    class="text-left"
    :rules="rules"
    ref="form"
  >
    <el-row :gutter="30">
      <el-col :span="9" :sm="4" class="pd-r-less">
        <el-form-item label="คำนำหน้าชื่อ" prop="prefix">
          <el-select
            v-model="form.prefix"
            placeholder="คำนำหน้าชื่อ"
            style="width: 100%;"
          >
            <el-option
              v-for="item in prefixList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="15" :sm="8">
        <el-form-item label="ชื่อภาษาไทย" prop="nameTh">
          <el-input v-model="form.nameTh"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="นามสกุลภาษาไทย" prop="lastNameTh">
          <el-input v-model="form.lastNameTh"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ชื่อภาษาอังกฤษ" prop="nameEn">
          <el-input v-model="form.nameEn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="นามสกุลภาษาอังกฤษ" prop="lastNameEn">
          <el-input v-model="form.lastNameEn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="หมายเลขโทรศัพท์" prop="phoneNumber">
          <VuePhoneNumberInput
            v-model="form.phoneNumber"
            @update="updatePhoneNumber"
            :default-country-code="phoneNumber.countryCode"
            color="#353535"
            error-color="#C81800"
            valid-color="#00C88C"
            :error="!phoneNumber.numberValid"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="อีเมล" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row  :gutter="30">
      <el-col :span="24" :sm="12">
        <el-form-item label="รหัสผ่าน" prop="password">
          <el-input v-model="form.password" :type="hidePass?'password':''" autocomplete="off">
              <span slot="suffix">
                <i v-if="hidePass" @click="hidePass = false" class="cursor-pointer fas fa-eye mg-r-5"></i>
                <i v-else @click="hidePass = true" class="cursor-pointer fas fa-eye-slash mg-r-5"></i>
              </span>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24" :sm="12">
        <el-form-item label="ยืนยันรหัสผ่าน" prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            :type="hideConfirmPass?'password':''"
            autocomplete="off"
          >
            <span slot="suffix">
              <i v-if="hideConfirmPass" @click="hideConfirmPass = false" class="cursor-pointer fas fa-eye mg-r-5"></i>
              <i v-else @click="hideConfirmPass = true" class="cursor-pointer fas fa-eye-slash mg-r-5"></i>
            </span>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createAdmin"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มผู้ดูแลระบบ</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateAdmin"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";

export default {
  components: {
    VuePhoneNumberInput,
    ThailandAutoComplete,
  },
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    admin: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("รหัสผ่านไม่ตรงกัน"));
      } else {
        callback();
      }
    };
    var validatePhoneNumber = (rule, value, callback) => {
      if (!this.phoneNumber.numberValid) {
        callback(new Error("กรุณากรอกหมายเลขโทรศัพท์ให้ถูกต้อง"));
      } else {
        callback();
      }
    };
    var validateThai = (rule, value, callback) => {
      let regx = /^[^a-z^A-Z]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกตัวอักษรภาษาไทย"));
      } else {
        callback();
      }
    };
    var validateEng = (rule, value, callback) => {
      let regx = /^[^ก-๛]+$/i;
      if (!regx.test(value)) {
        callback(new Error("กรุณากรอกตัวอักษรภาษาอังกฤษ"));
      } else {
        callback();
      }
    };
    return {
      form: {
        prefix: "",
        nameTh: "",
        lastNameTh: "",
        nameEn: "",
        lastNameEn: "",
        phoneNumber: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        prefix: [
          {
            required: true,
            message: "กรุณาเลือกคำนำหน้าชื่อ",
            trigger: ["blur", "change"],
          },
        ],
        nameTh: [
          { required: true, message: "กรุณากรอกชื่อภาษาไทย", trigger: "blur" },
          { validator: validateThai, trigger: "blur" },
        ],
        lastNameTh: [
          {
            required: true,
            message: "กรุณากรอกนามสกุลภาษาไทย",
            trigger: "blur",
          },
          { validator: validateThai, trigger: "blur" },
        ],
        nameEn: [
          {
            required: true,
            message: "กรุณากรอกชื่อภาษาอังกฤษ",
            trigger: "blur",
          },
          { validator: validateEng, trigger: "blur" },
        ],
        lastNameEn: [
          {
            required: true,
            message: "กรุณากรอกนามสกุลภาษาอังกฤษ",
            trigger: "blur",
          },
          { validator: validateEng, trigger: "blur" },
        ],
        phoneNumber: [{ validator: validatePhoneNumber, trigger: "blur" }],
        email: [
          {
            required: true,
            message: "กรุณากรอกอีเมล",
            trigger: "blur",
          },
          {
            type: "email",
            message: "กรุณากรอกอีเมลให้ถูกต้อง",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "กรุณากรอกรหัสผ่าน", trigger: "blur" },
          {
            min: 8,
            message: "กรุณากรอกรหัสผ่านอย่างน้อย 8 ตัวขึ้นไป",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "กรุณากรอกยืนยันรหัสผ่าน",
            trigger: "blur",
          },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
      phoneNumber: {
        countryCode: "TH",
        formatNational: "",
        numberValid: true,
      },
      hidePass:true,
      hideConfirmPass:true
    };
  },
  watch: {
    admin() {
      this.setAdmin();
    },
  },
  created() {
    if (this.type == 'update') {
      let password = this.rules.password.slice(1,this.rules.password.length)
      let confirmPassword = this.rules.confirmPassword.slice(1,this.rules.password.length)

      this.rules.password = password
      this.rules.confirmPassword = confirmPassword
    }
  },
  mounted() {
    this.setAdmin();
  },
  methods: {
    setAdmin() {
      if (this.admin != null) {
        this.form = {
          prefix: this.admin.titleName,
          nameTh: this.admin.nameTH,
          lastNameTh: this.admin.surnameTH,
          nameEn: this.admin.nameEN,
          lastNameEn: this.admin.surnameEN,
          phoneNumber: this.admin.mobilephone,
          email: this.admin.email,
          password: '',
          confirmPassword: '',
        };

        this.phoneNumber.countryCode = this.admin.countryCode;
      }
    },
    createAdmin() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.form));
          obj["countryCode"] = this.phoneNumber.countryCode;
          this.$emit("createAdmin", obj);
        }
      });
    },
    updateAdmin() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.form));
          obj["countryCode"] = this.phoneNumber.countryCode;
          this.$emit("updateAdmin", obj);
        }
      });
    },
    updatePhoneNumber(payload) {
      this.form.phoneNumber = payload && typeof payload.phoneNumber != 'undefined'
        ? payload.phoneNumber.replace(/[\s (]/g, "")
        : "";
      this.phoneNumber.countryCode = payload.countryCode;
      this.phoneNumber.formatNational = payload.formatNational;
      this.phoneNumber.numberValid = payload.isValid;
    },
  },
};
</script>

<style scoped>
.input-time-learn {
  width: 130px;
}

.image-preview-course {
  width: 370px;
  height: 200px;

  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 5px;
  position: relative;
}
.icon-preview-image {
  position: absolute;
  right: -4px;
  top: -4px;
  color: #c4c4c4;
  cursor: pointer;
  background: #fff;
  border-radius: 20px;
}
.show-preview {
  height: 230px;
}
</style>
